import { Component, OnInit, OnDestroy, AfterViewInit, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import { GridDataResult, GridComponent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, SortDescriptor, orderBy } from '@progress/kendo-data-query';

//import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

import {environment} from '../../environments/environment';

@Component({
  selector: 'app-cost-hour-definitions',
  templateUrl: './cost-hour-definitions.component.html',
  styleUrls: ['./cost-hour-definitions.component.css']
})
export class CostHourDefinitionsComponent implements OnInit, OnDestroy, AfterViewInit {

  private loaded = false;
  public gridData: any[] = [];
  public gridView: GridDataResult;
  public state: State = {
    skip: 0,
    take: 25
  };

  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;
  initialLoad = false;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }


  ngAfterViewInit() {
    this.reload();
    this.initialLoad = true;
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridView = process(this.gridData, this.state);
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.CostHourDefinitions.columns;
    this.data = this.report.CostHourDefinitions.data;
    this.gridData = this.report.CostHourDefinitions.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
    this.gridView = process(this.gridData, this.state);
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.gridData = this.report.CostHourDefinitions.data;
    this.gridView = process(this.gridData, this.state);
  }

}


// WEBPACK FOOTER //
// ./src/app/cost-hour-definitions/cost-hour-definitions.component.ts